export const getUserDisplayName = (user: (Pick<IUser, 'email'> & Partial<Pick<IUser, 'name'>>) | null) => {
  if (!user?.email) return '?'

  const userNameWithoutLeadingOrTrailingWhitespaces = user.name?.trim()
  if (!userNameWithoutLeadingOrTrailingWhitespaces) return user.email

  return userNameWithoutLeadingOrTrailingWhitespaces
}
